// extracted by mini-css-extract-plugin
export default {"form":"FirstTimeDepositForm_form__8SuQs","formItem":"FirstTimeDepositForm_formItem__o9r0r","currencyFieldWrapper":"FirstTimeDepositForm_currencyFieldWrapper__q8Q3V"};